<form [formGroup]="DinamicForm" >
    <dnc-title [check]="check" [editable]="editable"></dnc-title>
    <div class="input-group">
        <div class="input-group-prepend" *ngIf="check?.options?.prefix"><div class="input-group-text"><span class="lh--9 op-6">{{check?.options.prefix}}</span></div></div>
        <input type="text" class="form-control inputNumber" #input [readonly]="(check?.target?.readonly || !editable)"
        [placeholder]="check.target.placeholder" (keypress)="validType($event, input)" (change)="dynamicEmit($event)" (paste)="pasteIsInteger($event)" [formControlName]="this.check.formControlName"  [maxlength]="check?.target?.validators?.maxLength || check?.target?.maxLength">
    </div>
    <small class="text-danger" *ngIf="fieldisValid.campoEsValido(this.check.formControlName, DinamicForm) && eventMessage">{{check.validateMessage}}</small>
</form>
